module.exports = __webpack_public_path__ + "media/images/hero/home-hero-left-6e83e96a0eeb1105b2b0cf9109815b14.svg";